import { useCallback, useMemo, useState } from 'react';
import constate from '../../common/lib/constate';

function useLogo() {
  const [isLogoEditor, setIsLogoEditor] = useState(false);
  const [currentLogoFromEditor, setCurrentLogoFromEditor] = useState(null);

  const enableLogoEditor = useCallback(() => {
    setIsLogoEditor(true);
  }, []);

  const disableLogoEditor = useCallback(() => {
    setCurrentLogoFromEditor(null);
    setIsLogoEditor(false);
  }, [setIsLogoEditor]);

  return useMemo(
    () => ({
      isLogoEditor,
      enableLogoEditor,
      disableLogoEditor,
      currentLogoFromEditor,
      setCurrentLogoFromEditor,
    }),
    [isLogoEditor, currentLogoFromEditor]
  );
}

export const useLogoContext = constate(useLogo);

const LogoContext = {
  Provider: useLogoContext.Provider,
};

export default LogoContext;
